import httpManager from "@/app/shared/utils/httpManager";

export interface CreateAccountWithContactPayload {
  name: string;
  email: string;
  contact_name: string;
  contact_number: string;
  country: number;
}

/**
 * Creates a WhatsApp Business account with a contact
 */
export async function createAccountWithContact(payload: CreateAccountWithContactPayload) {
  const url = `/channels/gupshup-waba/create-with-contact/`;
  const response = await httpManager.post(url, payload);
  return response?.data;
}